import { useNavigate } from "react-router-dom";
import "../styles/ImportantIntroPage.css";

const VIDEO_URL = "https://www.youtube.com/embed/f6Iv6BkuPMk";
const DEFAULT_NEXT_PATH = "/important-consumer-info";

export default function ImportantIntroPage({ nextPath = DEFAULT_NEXT_PATH }) {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate(nextPath);
  };

  return (
    <div className="ii-page">
      <header className="ii-header">
        <div className="ii-headerInner">
          <div className="ii-titleBlock">
            <h1 className="ii-title">Importante!</h1>
            <p className="ii-subtitle">
              Fizemos algumas atualizações importantes em seu contrato que
              solicitamos que você analise e aceite.
            </p>
          </div>
        </div>
      </header>

      <main className="ii-main">
        <section className="ii-card" aria-labelledby="important-intro-title">
          <div className="ii-cardHeader">
            <h2 id="important-intro-title" className="ii-cardTitle">
              Por que isso é importante?
            </h2>
            <p className="ii-cardHint">
              Assista ao nosso vídeo explicativo para entender mais.
            </p>
          </div>

          <div className="ii-content">
            <div className="ii-videoWrap">
              <iframe
                className="ii-video"
                src={VIDEO_URL}
                title="Resumo Simplificado - Vídeo explicativo"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>

            <button
              type="button"
              className="ii-continue"
              onClick={handleContinue}
            >
              Veja os termos atualizados
            </button>
          </div>
        </section>
      </main>
    </div>
  );
}
